export const OUTCOME_HORIZONS = ['1h', '24h', '7d'];

export function getOutcomeStatus(direction, fwdReturn, threshold = 0.005) {
  const dir = String(direction || '').trim().toUpperCase();
  const ret = Number(fwdReturn);
  if (!Number.isFinite(ret)) return 'pending';
  if (dir === 'LONG') return ret > threshold ? 'matched' : 'did-not-match';
  if (dir === 'SHORT' || dir === 'AVOID') return ret < -threshold ? 'matched' : 'did-not-match';
  return 'pending';
}

export function shouldShowOutcomeRow(thesis, minHours = 24) {
  const ts = thesis && thesis.ts_created ? Date.parse(String(thesis.ts_created)) : NaN;
  if (!Number.isFinite(ts)) return false;
  return (Date.now() - ts) >= (minHours * 60 * 60 * 1000);
}

export function buildOutcomeBadges(thesis) {
  const outcomes = thesis && thesis.outcomes_summary ? thesis.outcomes_summary : {};
  return OUTCOME_HORIZONS.map((horizon) => {
    const item = outcomes && outcomes[horizon] ? outcomes[horizon] : null;
    const fwdReturn = item && item.fwd_return != null && item.fwd_return !== ''
      ? Number(item.fwd_return)
      : Number.NaN;
    return {
      horizon,
      fwdReturn,
      status: getOutcomeStatus(thesis && thesis.direction, fwdReturn),
    };
  });
}
